import './index.scss'
import Swiper from 'swiper/js/swiper.min.js'

var beforeScroH = $(document).scrollTop();
$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //滚动高度
  var viewH = $(window).height(); //可见高度
  $('.section1 .bg').css('transform','translateY('+ scroH / 5 +'px)')

  //浮动二级导航效果
  let fixedNav = $('.section2').offset().top
  let tranH = $('.pc-header .header').outerHeight()-1
  if(scroH > fixedNav){
    if($(window).width()>1024){
      $('.section2 .sec2-fixed').addClass('fixed')
    }else{
      $('.section2 .sec2-fixed').addClass('fixed').css('transform','translateY('+ tranH +'px)')
    }
  }else{
    if($(window).width()>1024){
      $('.section2 .sec2-fixed').removeClass('fixed')
    }else{
      $('.section2 .sec2-fixed').removeClass('fixed').css('transform','translateY(0px)')
    }
  }

  //判断页面是上滚还是下滚
  var delta = scroH - beforeScroH;
  if($(window).width()>1024){
    if(scroH > fixedNav){
      if (delta > 0) {
        $('.section2 .sec2-fixed').css('transform','translateY(0px)')
      }
      if (delta < 0) {
        
        $('.section2 .sec2-fixed').css('transform','translateY('+ tranH +'px)')
      }
    }else{
      $('.section2 .sec2-fixed').css('transform','translateY(0px)')
    }
  }
  beforeScroH = scroH;


  //二级导航高亮对应
  let page1H = $('#page1').offset().top - viewH/4
  let page2H = $('#page2').length > 0 ? $('#page2').offset().top - viewH/4 : page1H
  let page3H = $('#page3').length > 0 ? $('#page3').offset().top - viewH/4 : page2H
  let page4H = $('#page4').length > 0 ? $('#page4').offset().top - viewH/4 : page3H
  let page5H = $('#page5').length > 0 ? $('#page5').offset().top - viewH/4 : page4H
  let page6H = $('#page6').length > 0 ? $('#page6').offset().top - viewH/4 : page5H
  let page7H = $('#page7').length > 0 ? $('#page7').offset().top - viewH/4 : page6H
  if(scroH < page2H){
    $('.section2 .scroll-cont a').eq(0).addClass('active').siblings().removeClass('active')
  }else if(scroH > page2H && scroH < page3H){
    $('.section2 .scroll-cont a').eq(1).addClass('active').siblings().removeClass('active')
  }else if(scroH > page3H && scroH < page4H){
    $('.section2 .scroll-cont a').eq(2).addClass('active').siblings().removeClass('active')
  }else if(scroH > page4H && scroH < page5H){
    $('.section2 .scroll-cont a').eq(3).addClass('active').siblings().removeClass('active')
  }else if(scroH > page5H && scroH < page6H){
    $('.section2 .scroll-cont a').eq(4).addClass('active').siblings().removeClass('active')
  }else if(scroH > page6H && scroH < page7H){
    $('.section2 .scroll-cont a').eq(5).addClass('active').siblings().removeClass('active')
  }else if(scroH > page7H){
    $('.section2 .scroll-cont a').eq(6).addClass('active').siblings().removeClass('active')
  }


  //系统组成
  if (window.screen.width > 1024){
    if(scroH < $('.section4').offset().top){
      $('.section4 .fixed-cont').removeClass('fixed')
    }else if(scroH > $('.section4').offset().top && scroH < $('.section5').offset().top - viewH){
      $('.section4 .fixed-cont').addClass('fixed').removeClass('abs')
    }else{
      $('.section4 .fixed-cont').addClass('abs').removeClass('fixed')
    }

    if(scroH < $('.section4').offset().top + viewH/2){
      swiper4.slideTo(0)
    }else if(scroH > $('.section4').offset().top + viewH/2 && scroH < $('.section4').offset().top + viewH){
      swiper4.slideTo(1)
    }else if(scroH > $('.section4').offset().top + viewH && scroH < $('.section4').offset().top + viewH*1.5){
      swiper4.slideTo(2)
    }else if(scroH > $('.section4').offset().top + viewH*1.5 && scroH < $('.section4').offset().top + viewH*2){
      swiper4.slideTo(3)
    }
  }
});

$(document).ready(function(){
  $('.section2 .scroll-cont a').eq(0).addClass('active');
  getsec4H()
  if($(window).width() < 768){
    $('.sec4-cont li .item-desc').show()
  }else{
    $('.sec4-cont li .item-desc').hide()
    $('.sec4-cont li.active .item-desc').show()
  }
})

function getsec4H(){
  let length = $('.section4 .sec4-cont li').length + 1
  let html = ''
  for(let i=0; i<length;i++){
    html +=`<div class="zw${i}"></div>`
  }
  $('.section4 .zhanwei-cont').html(html)
}

var swiper4 = new Swiper(".section4 .sec4-right .mySwiper", {
  allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on: {
    init: function(swiper){
      $('.section4 .sec4-cont li').eq(this.activeIndex).addClass('active').find('.item-desc').slideDown()
    },
    slideChangeTransitionStart: function(){
      $('.section4 .sec4-cont li .item-desc').slideUp()
      $('.section4 .sec4-cont li').eq(this.activeIndex).addClass('active').siblings().removeClass('active')
      $('.section4 .sec4-cont li').eq(this.activeIndex).find('.item-desc').slideDown()
    },
  },
});

$(".section4 .sec4-cont li").on('click',function(){
  if($(window).width() <= 1024 && $(window).width() >= 768){
    let index = $(this).index()
    if (window.screen.width >= 768){
      swiper4.slideTo(index)
    }
  }
})

var swiper5 = new Swiper(".section5 .sec5-swiper .mySwiper", {
  allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on: {
    init: function(swiper){
      $('.section5 .sec5-tab div').eq(0).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section5 .sec5-tab div').eq(this.activeIndex).addClass('active').siblings().removeClass('active')
    },
  },
});

$('.section5 .sec5-tab div').hover(function(){
  let index = $(this).index()
  swiper5.slideTo(index)
})

var swiper7 = new Swiper(".section7 .sec7-swiper .mySwiper", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 10,
  pagination: {
    el: ".section7 .sec7-swiper .swiper-pagination",
    clickable: true
  },
  breakpoints: {
    1025: {  //当屏幕宽度小于等于768
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 40,
    },
    640: {  //当屏幕宽度小于等于320
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 20,
    }
  } 
});

// $(window).resize(function(){
//   if($(window).width() < 768){
//     $('.sec4-cont li .item-desc').show()
//   }else{
//     $('.sec4-cont li .item-desc').hide()
//     $('.sec4-cont li.active .item-desc').show()
//   }
// })